// ResolveDefectDialog: shared "mark defect as completed" dialog for the places
// that open defect threads outside Asset View (the /defects inbox and the
// top-bar callout). Same request contract as the legacy Asset View resolve
// dialog: POST defect/resolved { assetId, defectId, resolvedComment }, which
// also drops the "Marked completed by ..." SYSTEM message into the thread.
//
// Props: defect (row with id + assetId, or null = closed), onClose, onResolved.

import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { baseUrl } from '../../shared';

export default function ResolveDefectDialog({ defect, onClose, onResolved }) {
  const [resolutionText, setResolutionText] = useState('');
  const [resolving, setResolving] = useState(false);
  const [error, setError] = useState('');

  // Fresh form every time a new defect is targeted.
  useEffect(() => {
    setResolutionText('');
    setError('');
  }, [defect]);

  async function submit() {
    if (!defect || !resolutionText.trim() || resolving) return;
    setResolving(true);
    setError('');
    try {
      const res = await fetch(baseUrl + 'defect/resolved/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          username: localStorage.getItem('username'),
          bToken: localStorage.getItem('bToken'),
        },
        body: JSON.stringify({
          assetId: defect.assetId,
          defectId: defect.id,
          resolvedComment: resolutionText.trim(),
        }),
      });
      const data = await res.json();
      if (!data[0] || data[0].status !== 200) throw new Error((data[0] && data[0].message) || 'Defect could not be resolved');
      if (onResolved) onResolved();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setResolving(false);
    }
  }

  return (
    <Dialog open={defect !== null} onClose={onClose}>
      <DialogTitle>Resolve Defect</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please enter resolution for Defect to mark as closed.
        </DialogContentText>
        <br />
        <TextField
          autoFocus
          multiline
          required
          margin="dense"
          label="Defect Resolution"
          fullWidth
          variant="standard"
          value={resolutionText}
          onChange={(e) => setResolutionText(e.target.value)}
        />
        {error && (
          <Typography variant="caption" sx={{ color: 'var(--fail)', display: 'block', mt: 1 }}>{error}</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', borderTop: '1px solid var(--border)' }}>
        <Button onClick={onClose} variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }}>Cancel</Button>
        <Button onClick={submit} variant="contained" color="success" disabled={resolving || !resolutionText.trim()}>
          {resolving ? 'Resolving...' : 'Resolve'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
